// Entry point. Bootstraps the game into #game-root.

import { startGame } from './game.js';

const root = document.getElementById('game-root');
if (!root) throw new Error('#game-root not found in index.html');

startGame(root).catch((err) => {
  console.error('Failed to start game:', err);
});
